// extracted by mini-css-extract-plugin
export default {"input":"InputController_input__+1SD7","error":"InputController_error__3PSuS","label":"InputController_label__Yy0+G"};